import { render, staticRenderFns } from "./Stands.vue?vue&type=template&id=9a160d56"
import script from "./Stands.vue?vue&type=script&lang=js"
export * from "./Stands.vue?vue&type=script&lang=js"
import style0 from "./Stands.vue?vue&type=style&index=0&id=9a160d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports